import { useId } from 'react';
import { Checkbox, FieldLabel, FieldRoot } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { InformationmarkSmallCircleIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { QuizCard } from '@/shared/components/QuizCardV2';
import { Tooltip } from '@/ui_v3';
import { useEditMode } from '../../focus/useIsEditMode';
import { useQuizFormField } from '../hook/useQuizFormField';
const SPACELESS_LOCALES = new Set(['ja', 'zh-CN', 'zh-TW', 'zh-HK', 'th', 'km']);
export const SubjectiveSpacingOption = () => {
  const {
    i18n
  } = useTranslation();
  const {
    isEditMode,
    onEditModeChange
  } = useEditMode();
  const [ignoreSpaces, setIgnoreSpaces] = useQuizFormField({
    field: 'subjectiveData.ignoreSpaces'
  });
  if (!isEditMode) {
    return <QuizCard.SpacingRule ignoreSpaces={ignoreSpaces} onClick={() => onEditModeChange(true)} />;
  }

  // 이미 켜진 문항은 이 언어에서도 끌 수 있게 남긴다.
  if (SPACELESS_LOCALES.has(i18n.language) && ignoreSpaces !== false) {
    return null;
  }
  return <SpacingCheckbox checked={ignoreSpaces === false} onCheckedChange={checked => setIgnoreSpaces(!checked)} data-sentry-element="SpacingCheckbox" data-sentry-component="SubjectiveSpacingOption" data-sentry-source-file="SubjectiveSpacingOption.tsx" />;
};
const SpacingCheckbox = ({
  checked,
  onCheckedChange
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) => {
  const {
    t
  } = useTranslation(['common', 'build']);
  const checkboxId = useId();
  const tooltip = t('build:createSubjective.ignoreSpaces.tooltip');
  return <div className="flex items-center gap-sm pb-xs" data-sentry-component="SpacingCheckbox" data-sentry-source-file="SubjectiveSpacingOption.tsx">
      <Checkbox id={checkboxId} checked={checked} onCheckedChange={value => onCheckedChange(value === true)} data-sentry-element="Checkbox" data-sentry-source-file="SubjectiveSpacingOption.tsx" />
      <div className="flex items-center gap-3xs">
        {/* `FieldRoot` 에 `required` 를 주지 않으면 라벨 옆에 `(optional)` 이 붙는다. */}
        <label htmlFor={checkboxId} className="cursor-pointer">
          <FieldRoot required className="w-auto" data-sentry-element="FieldRoot" data-sentry-source-file="SubjectiveSpacingOption.tsx">
            <FieldLabel variant="control" data-sentry-element="FieldLabel" data-sentry-source-file="SubjectiveSpacingOption.tsx">
              {t('common:quizItem.spacingRule.description')}
            </FieldLabel>
          </FieldRoot>
        </label>
        <Tooltip.Provider data-sentry-element="unknown" data-sentry-source-file="SubjectiveSpacingOption.tsx">
          <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="SubjectiveSpacingOption.tsx">
            <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="SubjectiveSpacingOption.tsx">
              <button type="button" aria-label={tooltip} className="flex">
                <InformationmarkSmallCircleIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="InformationmarkSmallCircleIcon" data-sentry-source-file="SubjectiveSpacingOption.tsx" />
              </button>
            </Tooltip.Trigger>
            <Tooltip.Content arrow data-sentry-element="unknown" data-sentry-source-file="SubjectiveSpacingOption.tsx">{tooltip}</Tooltip.Content>
          </Tooltip.Root>
        </Tooltip.Provider>
      </div>
    </div>;
};